import { buildQueryString, getAPI, postAPI } from "../api";
import { components } from "../api/openapi";
import { Page } from "@bagel-web/common";

export type Declaration = components["schemas"]["Declaration"];
export type FeatureFlag = components["schemas"]["FeatureFlag"];
export type FeatureFlagUpdate = components["schemas"]["FeatureFlagUpdate"];

export const fetchFeatureFlags = (): Promise<Page<Declaration>> => {
  return getAPI("/api/feature-flags");
};

export const fetchFeatureFlag = (flagName: string): Promise<FeatureFlag> => {
  return getAPI(`/api/feature-flags/${flagName}`);
};

export const updateFeatureFlag = (
  flagName: string,
  update: FeatureFlagUpdate
): Promise<FeatureFlag> => {
  return postAPI(`/api/feature-flags/${flagName}`, update);
};

export function fetchFeatureFlagStates(
  flagNames: Array<string>
): Promise<Record<string, boolean>> {
  return getAPI(
    buildQueryString("/api/feature-flag-states", { flag_names: flagNames })
  );
}
